const isPressing = new WeakSet();
export { isPressing };